/* eslint-disable @typescript-eslint/camelcase */
import {
  FeedInfoUrl,
  FeedTagInfoUrl,
  checkUser,
  GoodsListUrl,
  AddCartUrl,
  CommentListUrl,
  CommentUpUrl,
  CollectAddUrl,
  CollectDelUrl,
  PraiseAddUrl,
  PraiseDelUrl,
  CommentReplyListUrl,
  CommentAddUrl,
  RemoveFollowUrl,
  AddFollowUrl,
  UserIneractUrl,
  FeedDeleteUrl,
  RankUsersUrl,
  RankShopUrl,
  RankDates,
  RankVideoUrl,
  RankTypeUrl,
  RankRulesUrl,
  MtFeedInfoUrl,
  CommentReportAdd,
  CommentDel,
  LiveReportTypes,
  FeedDraftDetail,
  FeedDraftPreview,
  collectAdd,
  collectDel,
  goodsDetail,
  CommentListUrlNew,
  subscribe,
} from './url'
import { getParams } from './data-factory'
import networkRequest from './fetch'
import { CommentParams } from '@/store/types'

/**
 * 动态详情
 * @param feedId
 */
export function fetchFeedInfo(feedId: number) {
  return networkRequest({
    url: FeedInfoUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 * 动态关联的商品列表
 * @param feedId
 */
export function fetchGoodsList(feedId: number) {
  return networkRequest({
    url: GoodsListUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 * 加入购物车
 * @param goods_id
 */
export function fetchAddCart(goods_id: number) {
  return networkRequest({
    method: 'post',
    url: AddCartUrl,
    params: Object.assign({ goods_id }, getParams()),
  })
}

/**
 * 获取动态评论列表
 * @param feed_id
 * @param pn
 * @param pc
 */
export function fetchCommentList(params: CommentParams) {
  return networkRequest({
    url: CommentListUrlNew,
    params: Object.assign(params, getParams()),
  })
}

/**
 * 评论点赞
 * @param feed_id
 * @param comment_id
 * @param content
 * @param cuuid
 */
export function fetchCommentUp(feed_id: number, comment_id: number, content: string, cuuid: string) {
  return networkRequest({
    url: CommentUpUrl,
    params: Object.assign({ feed_id, comment_id, content, cuuid }, getParams()),
  })
}

/**
 * 动态点赞
 * @param feedId
 */
export function doPraiseAdd(feedId: number) {
  return networkRequest({
    url: PraiseAddUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 *  动态取消点赞
 * @param feedId
 */
export function doPraiseDel(feedId: number) {
  return networkRequest({
    url: PraiseDelUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 * 动态收藏
 * @param feedId
 */
export function doFeedAdd(feedId: number) {
  return networkRequest({
    url: CollectAddUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 * 动态取消收藏
 * @param feedId
 */
export function doFeedDel(feedId: number) {
  return networkRequest({
    url: CollectDelUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 * 获取回复评论列表
 * @param param0
 */
export function fetchCommentReplyList({ feed_id, comment_id, pc, pn }: any) {
  return networkRequest({
    url: CommentReplyListUrl,
    params: Object.assign({ feed_id, comment_id, pc, pn }, getParams()),
  })
}

/**
 * 发布评论
 * @param param0
 */
export function fetchCommentAdd({ feed_id, content, parent_id, at_user_info, comment_be_reply_info }: any) {
  return networkRequest({
    method: 'post',
    url: CommentAddUrl,
    params: Object.assign({ feed_id, content, parent_id, ctype: 0, at_user_info, comment_be_reply_info }, getParams()),
  })
}

/**
 * 举报评论
 * @param param0
 */
export function fetchCommentReport({
  feedId,
  commentId,
  tuuid,
  type,
  detail,
}: any) {
  return networkRequest({
    method: 'post',
    url: CommentReportAdd,
    params: Object.assign(
      { feedId, commentId, tuuid, type, detail },
      getParams()
    ),
  })
}

/**
 * 获取举报的类目信息
 * @param
 */
export function fetchLiveReportTypes() {
  return networkRequest({
    url: LiveReportTypes,
    params: Object.assign(getParams()),
  })
}

/**
 * 删除评论
 * @param param0
 */
export function doCommentDel({ feed_id, comment_id, ctype }: any) {
  return networkRequest({
    method: 'post',
    url: CommentDel,
    params: Object.assign({ feed_id, comment_id, ctype }, getParams()),
  })
}

/**
 * 取消关注
 * @param artistId
 * @param uid
 */
export function doRemoveFollow(artistId: string, uid: string) {
  return networkRequest({
    url: RemoveFollowUrl,
    params: Object.assign({ artistId, uid }, getParams()),
  })
}

/**
 * 添加关注
 * @param artistId
 * @param uid
 */
export function doAddFollow(artistId: string, uid: string) {
  return networkRequest({
    url: AddFollowUrl,
    params: Object.assign({ artistId, uid }, getParams()),
  })
}

/**
 * 动态内容 点赞、收藏 状态 （获取用户对某一条动态的 点赞收藏状态）
 * @param feedId
 */
export function fetchUserIneract(feedId: number) {
  return networkRequest({
    url: UserIneractUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 * 删除动态
 * @param feedId
 */
export function doFeedDelete(feedId: number) {
  return networkRequest({
    url: FeedDeleteUrl,
    params: Object.assign({ feedId }, getParams()),
  })
}

/**
 * 获取榜单类型
 */
export function getRankTypeList() {
  return networkRequest({
    url: RankTypeUrl,
  })
}
/**
 * 获取榜单日期
 */
export function getRankDates() {
  return networkRequest({
    url: RankDates,
  })
}
/**
 * 获取明星排行榜数据
 * @param typ
 */
export function getRankStarList(
  typ: number,
  rank_id: number,
  page: number = 1,
  pageSize: number = 20
) {
  return networkRequest({
    url: RankUsersUrl,
    params: Object.assign({ typ, rank_id, page, pageSize }, getParams()),
  })
}
/**
 * 获取商品排行榜数据
 * @param typ
 */
export function getRankShopList(typ: number, rank_id: number) {
  return networkRequest({
    url: RankShopUrl,
    params: Object.assign({ typ, rank_id }, getParams()),
  })
}
/**
 * 获取视频排行榜数据
 * @param typ
 */
export function getRankVideoList(typ: number, rank_id: number) {
  return networkRequest({
    url: RankVideoUrl,
    params: Object.assign({ typ, rank_id }, getParams()),
  })
}

/**
 * 获取视频排行榜数据
 * @param typ
 */
export function getRankRules(rank_id: number) {
  return networkRequest({
    url: RankRulesUrl,
    params: Object.assign({ rank_id }, getParams()),
  })
}

/**
 * 获取密逃feed信息
 * @param feedId
 */
export function getMtFeedInfo(
  feedId: number,
  localLat: number,
  localLng: number,
  isCompute: number
) {
  return networkRequest({
    url: MtFeedInfoUrl,
    params: Object.assign(
      { feedId, localLat, localLng, isCompute },
      getParams()
    ),
  })
}

/**
 * 获取图文草稿详情
 * @param
 */
export function getFeedDraftDetail(
  uuid: string,
  ticket: string,
  feedDraftId: number
) {
  return networkRequest({
    url: FeedDraftDetail,
    params: Object.assign({ uuid, ticket, feedDraftId }),
  })
}

/**
 * 图文草稿预览    ,
 * @param
 */
export function getFeedDraftPreview(params: any) {
  return networkRequest({
    method: 'post',
    url: FeedDraftPreview,
    params: Object.assign({}, { ...params }),
  })
}

/**
 * 动态详情
 * @param feedId
 */
export function fetchFeedTagInfo(
  tag_id: number,
  goods_id: number,
  pageNum: number
) {
  return networkRequest({
    url: FeedTagInfoUrl,
    params: Object.assign(
      { tag_id, goods_id, pageNum, pageSize: 10 },
      getParams()
    ),
  })
}

/**
 * 判断是否注销
 * @param tuuid
 */
export function checkUsers(tuuid: string) {
  return networkRequest({
    url: checkUser,
    params: Object.assign({ tuuid }, getParams()),
  })
}

/**
 * 收藏商品
 **/
export function fetchCollectAdd(goods_id: number) {
  return networkRequest({
    method: 'post',
    url: collectAdd,
    params: Object.assign({ goods_id }, getParams()),
  })
}

/**
 * 取消商品
 **/
export function fetchCollectDel(goods_ids: number) {
  return networkRequest({
    method: 'post',
    url: collectDel,
    params: Object.assign({ goods_ids }, getParams()),
  })
}

/**
 * 商品列表
 * @param goods_ids
 */
export function fetchGoodsDetail(goods_ids: string) {
  return networkRequest({
    url: goodsDetail,
    params: Object.assign({ goods_ids }, getParams()),
  })
}

/**
 * 预约活动
 * @param goods_ids
 */
export function fetchSubscribe(param: any) {
  return networkRequest({
    url: subscribe,
    params: Object.assign({}, { ...param }),
  })
}
